module.exports = __webpack_public_path__ + "static/media/instrument4.00f788b5.jpg";